import { push } from 'react-router-redux';

export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST'
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS'
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE'

export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'

const initialState = {
    isFetching: false,
    user: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case GET_CURRENT_USER_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        user: action.user,
        errorMessage: ''
      })
    case GET_CURRENT_USER_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.message
      })
    case REGISTER_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        user: action.creds
      })
    case REGISTER_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: ''
      })
    case REGISTER_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.message
      })
    default:
      return state
  }
}



function requestGetCurrentUser() {
  return {
    type: GET_CURRENT_USER_REQUEST,
    isFetching: true
  }
}

function receiveGetCurrentUser(user) {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    isFetching: false,
    user
  }
}

function getCurrentUserError(message) {
  return {
    type: GET_CURRENT_USER_FAILURE,
    isFetching: false,
    message
  }
}

function requestRegister() {
  return {
    type: REGISTER_REQUEST,
    isFetching: true
  }
}

function receiveRegister(user) {
  return {
    type: REGISTER_SUCCESS,
    isFetching: false
  }
}

function registerError(message) {
  return {
    type: REGISTER_FAILURE,
    isFetching: false,
    message
  }
}

export function getCurrentUser() {


  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestGetCurrentUser())

    const id = localStorage.getItem('userId')
    if (!id) return dispatch(getCurrentUserError('Id not find'))

    return fetch(`/api/users/${id}`)
      .then(response =>
        response.json().then(user => ({ user, response }))
            ).then(({ user, response }) =>  {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(getCurrentUserError(user.message))
          return Promise.reject(user)
        } else {
          // If login was successful, set the token in local storage
          // localStorage.setItem('id_token', user.token)
          // Dispatch the success action
          dispatch(receiveGetCurrentUser(user))
        }
      }).catch(err => console.log("Error: ", err))
  }
}


export function registerUser(creds) {

  let config = {
    method: 'POST',
    headers: { 'Content-Type':'application/x-www-form-urlencoded' },
    body: `email=${creds.email}&firstName=${creds.firstName}&lastName=${creds.lastName}&password=${creds.password}&laboratory=${creds.laboratory}&permanent=${creds.permanent}`
  }

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestRegister(creds))

    return fetch('/api/users/', config)
      .then(response =>
        response.json().then(user => ({ user, response }))
            ).then(({ user, response }) =>  {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(registerError(user.message))
          return Promise.reject(user)
        } else {
          // If login was successful, set the token in local storage
          // localStorage.setItem('id_token', user.token)
          // Dispatch the success action
          dispatch(receiveRegister(user))
          dispatch(push('/login?registration=true'));
        }
      }).catch(err => console.log("Error: ", err))
  }
}



// WEBPACK FOOTER //
// ./src/modules/user.js